import {colors, font_s_md, shadow_box_xs} from '@xpertdox_js/xdstyle';

const styles = {
  dashSidebar: {
    position:"fixed",
    top: 0,
    transition: "transform .32s ease-out",
    zIndex: 1100,
    minWidth: "50px",
    maxWidth: '320px',
    height: "100vh",
  },
  container: {
    position:"relative",
    textAlign: 'center',
    width: '100%',
    maxWidth: '100%',
    height: '100vh',
  },
  menuToggle: {
    float: 'right',
    background: 'none',
  },
  hideSVG: {
    width: '25px',
    height: 'auto',
    display: 'block',
    fill: '#cd4e4d',
  },
  menusvg: {
    display: 'block',
    width: '30px',
    fill: '#25262c'
  },
  tabsContainer: {
    listStyle: 'none',
    padding: 0,
    margin:0,
  },
  navMenu: {
    position: 'relative',
    height: '100%',
    width: '100%'
  },
  topIcons: {
    position: 'absolute',
    top: 0, bottom: 'auto', left: 0, right: 0
  },
  bottomIcons: {
    position: 'absolute',
    bottom: 0, top: 'auto', left: 0, right: 0
  },
  navWrap: {
    display: 'table',
    width: '100%',
  },
  navContentWrap: {
    position: 'relative',
    zIndex: '1001',
    height: '100%',
    float: 'left',
    width: '50px',
    backgroundColor: colors.xdDarkBlue
  },
  navSubContentWrap: {
    width: '17.5rem',
    height: '100vh',
    float: 'right',
    background: '#fff',
    boxShadow: 'inset -.2rem 0 .8rem rgba(0,0,0,0.08), inset .2rem 0 .8rem rgba(0,0,0,0.08)',
    borderLeft: '1px solid rgba(0,0,0,0.12)',
    borderRight: '1px solid rgba(0,0,0,0.12)',
    overflow: 'auto',
    padding: '.8rem',
    transition: 'width 5s ease-out',
  },
  navSubContentWrapCollapsed: {
    width: '2.4rem',
  },
  navLink: {
    display:"block",
    width: "100%",
    background: "none",
    color: "#c2c6c9",
    textAlign: "left",
    transition: '.2s',
    border: 'none',
    padding: '10px 8px',
    borderBottom: '1px solid rgba(0,0,0,0.32)',
    borderTop: '1px solid rgba(255,255,255,0.05)',
    ...font_s_md,
  },
  navHover: {
    background: '#151a1e',
    borderTop: '1px solid rgba(255,255,255,0.0)',
  },
  navActive: {
    color: colors.xdHighlight,
    borderTop: '1px solid rgba(255,255,255,0.0)',
    background: '#151a1e',
  },
  navIconWrap: {
    transition: ".25s",
    backgroundColor: "#fff",
    position: "absolute",
    color: "#cd4e4c",
    cursor: "pointer",
    padding: "5px 0 5px",
    fontSize: '20px',
    borderRadius: "0px 500px 500px 0px",
    left: '82%',
    width: '10%',
    boxShadow: "0px 4px 5px -4px rgba(177, 177, 177, 0.3)",
    top: 0,
    opacity: 1,
  },
  navIconHidden: {
    opacity: 0,
    transform: 'translateX(-100%) scale(0)'
  },
  // instanceLogo: {
  //   float: 'left',
  //   width: '150px',
  //   display: 'none',
  // },
  feedback: {
    fontSize: '14px',
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    top: 'auto',
    padding: '5px',
  },
  subMenuItem: {
    ...font_s_md,
    background: 'none',
    color: colors.xdDarkBlue,
    borderBottom: 0,
    borderTop: 0,
    textAlign: 'left',
    display: 'block',
    width: '100%',
    padding: '8px 0 8px 18px',
    fontWeight: 500,
  },
  subMenuItemHov: {
    color: colors.xdDarkBlue,
    background: 'rgba(0,0,0,0.06)',
  },
  subMenuItemActive: {
    ...font_s_md,
    background: 'rgba(0,0,0,0.06)',
    padding: '8px 0 8px 18px',
    color: colors.xdDarkBlue,
    borderBottom: 0,
    borderTop: 0,
    fontWeight: 700,
    borderRadius: '4px',
  },
  expandBtn: {
    ...shadow_box_xs,
    position: 'absolute',
    right: 0,
    left: 'auto',
    top: '.7rem',
    transform: 'translateX(50%)',
    // fill: colors.xdDarkBlue,
    // stroke: colors.xdDarkBlue,
    // background: colors.offWhite,
  },
}

export default styles;
